import styled from 'styled-components'

import { ButtonDeleteUnstyled } from 'Components/Buttons/ButtonDelete/unstyled'

export const ButtonDelete = styled(ButtonDeleteUnstyled)`
  display: block;
  width: 44px;
  height: 44px;
  position: relative;
  background: ${props => props.theme.colors.regentGray};
  float: ${props => props.float};
  border-radius: 4px;
  cursor: pointer;

  svg {
    position: absolute;
    height: 100%;
    width: 14px;
    fill: ${props => props.theme.colors.white};
    left: 0;
    right: 0;
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonDelete/index.js